import Session from './session'

export default class SpLeaveAPI {

  static get PREFIX () {
    return Session.HOST + '/api/specialLeave/'
  }

  /**
   * 取得
   */
  static get (id) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'get/' + id)
  }

  /**
   * 登録
   */
  static create (body) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'create', body)
  }

  /**
   * 削除
   * @param {String} id ID
   */
  static delete (id) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + 'delete/' + id)
  }

  /**
   * 一覧取得
   */
  static list(params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + 'list', { params: params })
  }

  /**
  * 登録更新
  */
  static spUpsert(data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + 'upsert', data)
  }

 
}


// WEBPACK FOOTER //
// ./src/assets/js/api/sp-leave-api.js